module.exports = __webpack_public_path__ + "static/img/7.bdf86ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/zh/7.png
// module id = EsPs
// module chunks = 0